import Vue from 'vue'

export const emitter = new Vue()

export const events = {
  SESSION_CHECK: 'SESSION_CHECK'
}



// WEBPACK FOOTER //
// ./src/emitter.js